/**
 * Throws an error if no authToken is provided to it.
 * @param {String} authToken Auth token
 */
export const useAuthTokenError = (authToken) => {
  if (!authToken) throw new Error('No authToken provided for authenticated route')
}
